export enum SystemNameType {
  android = 'Android',
  ios = 'iOS',
}

export namespace SystemNameType {
  export const translateType = (type: SystemNameType): string => {
    switch (type) {
      case SystemNameType.android:
        return "Android";
      case SystemNameType.ios:
        return "iOS";
      default:
        return "";
    }
  };

  export const systemNameTypeChoices = Object.values(SystemNameType)
    .filter(x => typeof x === "string")
    .map((type) => ({
      id: type,
      name: SystemNameType.translateType(type),
    }));
}